Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _airbnbWithTracking = require('airbnb-with-tracking');

var _airbnbWithTracking2 = _interopRequireDefault(_airbnbWithTracking);

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _HorizontalScroll = require('../../private/HorizontalScroll');

var _HorizontalScroll2 = _interopRequireDefault(_HorizontalScroll);

var _withStyles = require('../../themes/withStyles');

var _tab = require('../../utils/propTypes/tab');

var _tab2 = _interopRequireDefault(_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {

  children: _tab2['default'],
  onPressTab: _propTypes2['default'].func,
  micro: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
  muted: _propTypes2['default'].bool,

  // set to true when performing default browser navigation without dynamic tab panel content
  navigationOnly: _propTypes2['default'].bool,

  scrollable: _propTypes2['default'].bool,
  small: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
  spacedTabs: _propTypes2['default'].bool,
  value: _propTypes2['default'].number
}));

var defaultProps = {
  children: undefined,
  onPressTab: function () {
    function onPressTab() {}

    return onPressTab;
  }(),

  micro: false,
  muted: false,
  navigationOnly: false,
  scrollable: false,
  small: false,
  spacedTabs: false,
  value: 0
};

/**
 * Tabs is a controlled component for a tab interface.
 * You should use this if you want to have full control
 * over the state of the component.

 * For the uncontrolled component equivalent, where it
 * just works out of the box, use TabsController.
 */
function Tabs(_ref) {
  var css = _ref.css,
      children = _ref.children,
      value = _ref.value,
      onPressTab = _ref.onPressTab,
      micro = _ref.micro,
      muted = _ref.muted,
      navigationOnly = _ref.navigationOnly,
      small = _ref.small,
      spacedTabs = _ref.spacedTabs,
      scrollable = _ref.scrollable,
      styles = _ref.styles;

  var chevronSize = small || micro ? 14 : 16;
  var tabs = _react2['default'].Children.map(children, function (tab, i) {
    return tab && _react2['default'].cloneElement(tab, {
      selected: value === i,
      onPress: function () {
        function onPress(e) {
          onPressTab(i, e);
        }

        return onPress;
      }(),

      micro: micro,
      muted: muted,
      navigationOnly: navigationOnly,
      small: small,
      spacedTabs: spacedTabs
    });
  });
  var tabsSection = tabs;
  if (scrollable) {
    tabsSection = _react2['default'].createElement(
      _HorizontalScroll2['default'],
      { chevronSize: chevronSize },
      tabs
    );
  }

  return _react2['default'].createElement(
    'div',
    null,
    _react2['default'].createElement(
      'div',
      _extends({
        role: navigationOnly ? null : 'tablist'
      }, css(styles.tabs, micro && styles.tabs_micro)),
      tabsSection
    ),
    _react2['default'].createElement(
      'div',
      null,
      _react2['default'].Children.map(children, function (tab, i) {
        if (tab && tab.props.children) {
          return _react2['default'].createElement(
            'div',
            _extends({
              role: 'tabpanel'
            }, css(i === value ? styles.show : styles.hide)),
            tab.props.children
          );
        }

        return null;
      })
    )
  );
}

Tabs.componentCategory = 'Core';
Tabs.displayName = 'Tabs';
Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Tabs.Tab = _Tab2['default'];

exports['default'] = (0, _airbnbWithTracking2['default'])('Tabs', ['onPressTab'])((0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color;
  return {
    tabs: {
      borderBottom: '1px solid ' + String(color.accent.hrGray),
      position: 'relative'
    },

    tabs_micro: {
      borderBottom: 'none'
    },

    hide: {
      display: 'none'
    },

    show: {
      display: 'block'
    }
  };
})(Tabs));
exports.Tab = _Tab2['default'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Tabs/index.js
// module id = 120
// module chunks = 923280921217 19843951674672